// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__1VgBp","header":"ClearentDisclaimer_header__23Ari","inner":"ClearentDisclaimer_inner__OJtsd"};